var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from 'react';
import { SelectContainer, SelectOptions, SelectOption } from '@styled/Select';
import FSButton from '@components/FSButton';
import { useOutsideClick } from '@hooks/useOutsideClick';
export default function ButtonSelect(_a) {
    var title = _a.title, icon = _a.icon, _b = _a.disabled, disabled = _b === void 0 ? false : _b, options = _a.options, onOption = _a.onOption, _c = _a.onClickClose, onClickClose = _c === void 0 ? true : _c;
    var _d = __read(useState(false), 2), show = _d[0], setShow = _d[1];
    var targetRef = useRef(null);
    useOutsideClick(targetRef, function () { return setShow(false); });
    var clickHandler = function (opt) {
        onOption(opt);
        if (onClickClose) {
            setShow(false);
        }
    };
    return (React.createElement("div", { ref: targetRef },
        React.createElement(SelectContainer, null,
            React.createElement(FSButton, { title: title, disabled: disabled, icon: icon, onClick: function () { return setShow(!show); } }),
            show && (React.createElement(SelectOptions, null, options.map(function (option, idx) {
                return (React.createElement(SelectOption, { onClick: function () { return clickHandler(option); }, key: "option-".concat(idx) }, option.label));
            }))))));
}
